/* lua.js generated code undefined */

let Base = unpack(require("clover/logic/userTagData/UserTagBase"))[0]
// let TagConfig = require("clover/config/userTag/ActiveDayTagConfig")
let Tag = xClass("ActiveDayTag", Base)
Tag.prototype.init = function () {
    let self = this
    self.record = table()
    self.activeDays = 0
    self.registerDays = 0
}
Tag.prototype.convertOnlineRecord = function (data) {
    let self = this
    // if __DEBUG then
    // 	return {record = {
    // 		1589004000,
    // 		1588964400,
    // 		1588878000
    // 	}}
    // end
    return table([1, "record", data.dayActives])
}
Tag.prototype.refresh = function (data) {
    let self = this
    if (data.record) {
        self.record = data.record
        self.activeDays = 0
        let daySet = table()
        let registerTime = UserManager.getInstance().getCreateTimeInSec()
        let registerDayStart = Localhost.getDayStartTimeByTS(registerTime)
        let todayStart = Localhost.getTodayStart()
        for (let _ in self.record) {
            let loginStamp = self.record[_]
            if ($null(loginStamp)) continue
            let dayStart = Localhost.getDayStartTimeByTS(loginStamp)
            let todayStart = Localhost.getTodayStart()
            let loginDay = Localhost.timeInDay(todayStart - dayStart)
            if (loginDay > 0 && loginDay <= 7) {
                if (daySet[dayStart] === null) {
                    daySet[dayStart] = loginStamp
                    if (dayStart !== todayStart) { //不含当天不含注册当天
                        self.activeDays = self.activeDays + 1
                    }
                }
            }
        }
        //计算注册天数
        self.registerDays = Localhost.timeInDay(todayStart - registerDayStart, false)
    }
}
Tag.prototype.getTag = function () {
    let self = this
    for (let label in TagConfig) {
        let v = TagConfig[label]
        if ($null(v)) continue
        if (v.type === "register") { //比较注册天数
            if (self.registerDays >= v.min && self.registerDays <= v.max) {
                // he_log_info(string.format("duration:%s",duration))
                return label
            }
        } else if (v.type === "login") { //比较登陆天数
            if (self.activeDays >= v.min && self.activeDays <= v.max) { //活跃天数（不含当天）
                return label
            }
        }
    }
    return 0
}
Tag.prototype.encode = function () {
    let self = this
    let data = table([1, "record", self.record])
    return data
}
module.exports = Tag
